import { useEffect } from 'react';

export function useOnUnmount(cleanupFn: () => void) {
    useEffect(() => {
        return () => {
            cleanupFn();
        };
    }, []); // oxlint-disable-line react-hooks/exhaustive-deps -- Unmount effects do not have deps
}
